import ViewTable from './ViewTable';

const OverLimitPriceViewTable = ({ dataTable }) => {
    // 非会員価格が上限以上の商品一覧
    const heads = [
        {
            title: 'JAN',
            field: 'jan',
            className: 'v-base_minWidth--95 v-base_width--6',
        },
        {
            title: '商品名',
            field: 'itemName',
            className: 'v-base_minWidth--115 v-width-auto',
        },
        {
            title: '現在の会員価格',
            field: 'discountedRequestSellingPrice',
            className: 'v-base_minWidth--115 v-width-auto',
        },
        {
            title: '非会員価格',
            field: 'requestSellingPrice',
            className: 'v-base_minWidth--115 v-width-auto',
        },
    ];

    const body = {
        columns: [
            {
                field: 'jan',
            },
            {
                field: 'itemName',
                className: 'text-left',
            },
            {
                field: 'discountedRequestSellingPrice',
            },
            {
                field: 'requestSellingPrice',
            },
        ],
    };

    return <ViewTable heads={heads} body={body} dataTable={dataTable} />;
};

export default OverLimitPriceViewTable;
